export function setMeta({ title, description, canonical, image, noIndex = false }) {
  if (title) document.title = title;
  const set = (name, content) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) { el = document.createElement('meta'); el.setAttribute('name', name); document.head.appendChild(el); }
    el.setAttribute('content', content || '');
  };
  const setOg = (property, content) => {
    let el = document.querySelector(`meta[property="${property}"]`);
    if (!el) { el = document.createElement('meta'); el.setAttribute('property', property); document.head.appendChild(el); }
    el.setAttribute('content', content || '');
  };
  if (description) set('description', description);
  if (canonical) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.setAttribute('rel','canonical'); document.head.appendChild(link); }
    link.setAttribute('href', canonical);
  }
  if (image) {
    setOg('og:image', image);
    set('twitter:image', image);
  }
  if (title) {
    setOg('og:title', title);
    set('twitter:title', title);
  }
  if (description) {
    setOg('og:description', description);
    set('twitter:description', description);
  }
  if (noIndex) {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement('meta'); robots.setAttribute('name','robots'); document.head.appendChild(robots); }
    robots.setAttribute('content','noindex,nofollow');
  }
}

export function injectJsonLd(json) {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(json);
  document.head.appendChild(script);
}
